import React from 'react';

import Icon from './Icon/Icon';

const CARD_ICON_MAP = {
  MASTERCARD: 'cards-visuals-mastercard',
  MC: 'cards-visuals-mastercard',
  'DEBIT MASTERCARD': 'cards-visuals-mastercard',
  'MASTER CARD': 'cards-visuals-mastercard',
  VISA: 'cards-visuals-visa',
  'VISA CREDIT': 'cards-visuals-visa',
  'VISA DEBIT': 'cards-visuals-visa',
  'VISA ELECTRON': 'cards-visuals-visa',
  DISCOVER: 'cards-visuals-discover',
  AMEX: 'cards-visuals-amex',
  'AMERICAN EXPRESS': 'cards-visuals-amex',
  DINERS: 'cards-visuals-diners',
  JCB: 'cards-visuals-jcb',
  MAESTRO: 'cards-visuals-maestro',
  CARD: 'credit-card-mono'
};

const CardProcessor = ({ children, style = {}, size = 44, iconSize = 20, className = '' }) => {
  if (!children) return null;

  const normalized = String(children).toUpperCase();

  if (normalized === 'ACH') {
    return (
      <div className="flex w-11 items-center justify-center rounded-md border border-solid border-neutral-200 p-1">
        <Icon icon="building-mono" size={iconSize} className={className} />
      </div>
    );
  }

  const icon = CARD_ICON_MAP[normalized];

  if (icon) {
    return (
      <Icon
        icon={icon}
        size={icon === 'credit-card-mono' ? iconSize : size}
        className={className}
      />
    );
  }

  return (
    <div className={className} style={style}>
      {children}
    </div>
  );
};

export default CardProcessor;
